module.exports = __webpack_public_path__ + "static/media/-_pay slip.daac5dd3.png";